/**
 * 总是返回一个固定的分数。 作为默认考虑，提供双重任务。
 */
export class FixedScoreConsideration {
    constructor(score = 1) {
        this.score = score;
    }
    getScore(_context) {
        return this.score;
    }
}
//# sourceMappingURL=FixedScoreConsideration.js.map